import { useQuery } from '@tanstack/react-query'
import { QuestionDetailsRes } from '@/types/question.type'
import { axiosInstance } from '@/lib/axios'
import { TypeValue } from '@/features/question-lib/constant'

interface PropsType {
  questionId: string
  questionType: string
}

export const getQuestionDetail = async ({
  questionId,
  questionType,
}: PropsType) => {
  const url =
    questionType === TypeValue.case_study ? '/question/case-study' : '/question'
  return axiosInstance.get<QuestionDetailsRes>(`${url}/${questionId}`)
}

export const useGetQuestionDetail = ({
  questionId,
  questionType,
}: PropsType) => {
  const { data, isLoading, isRefetching, refetch } = useQuery({
    queryKey: ['questionDetai', questionId, questionType],
    queryFn: () => getQuestionDetail({ questionId, questionType }),
    enabled: !!questionId,
  })

  return {
    questionDetail: data?.data,
    isLoadingQuestionDetail: isLoading || isRefetching,
    refetchQuestionDetail: refetch,
  }
}
